module.exports = __webpack_public_path__ + "media/categories/1027-680d6aa9.svg";